import * as fromBase from './admin.reducer';
import * as fromFittings from './fittings-admin.reducer';
import * as fromClosures from './closure-admin.reducer';
import { combineReducers } from '@ngrx/store';

export const adminFeatureKey = 'admin';

export interface State {
  base: fromBase.State,
  fittings: fromFittings.State,
  closures: fromClosures.State,
}

export const initialState = {
  base: fromBase.initialState,
  fittings: fromFittings.initialState,
  closures: fromClosures.initialState,
};

export const reducers = combineReducers({
  base: fromBase.reducer,
  closures: fromClosures.reducer,
  fittings: fromFittings.reducer,
});

export enum Loaders {
  loadingAppInfo = "loadingAppInfo",
  loadingDrawingMappings = "loadingDrawingMappings",
  loadingDetail = 'Loading Detail...',
  loadinglookup = 'Loading lookups',
  loadingDwg = "loadingDwg",
  loadingFittings = 'Loading Fittings...',
  loadConfigurations = "loadConfigurations",
  loadingMaintainenceEditorFitting = "loadingMaintainenceEditorFitting",
  loadingMaintenanceEditorAssociatedProducts = "loadingMaintenanceEditorAssociatedProducts",
  loadingAssociatedProductsForAdmin = "loadingAssociatedProductsForAdmin",
  loadingClosures = 'loading closures...',
};


